import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MapaPropriedadesPage } from './mapa-propriedades.page';

const routes: Routes = [
  {
    path: '',
    component: MapaPropriedadesPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MapaPropriedadesPageRoutingModule {}
